import api from './api';
export const companiesApi = { async index(filters) { const path = '/api/v1/companies'; const response = await api({ method: 'get', url: path, params: filters }); return response.companies; } };
